import { ApplicationConfig, provideBrowserGlobalErrorListeners, APP_INITIALIZER, PLATFORM_ID } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { WebAppConfigService } from './core/services/webapp-config.service';
import { GuestSession } from './core/services/guest-session';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { cacheControlInterceptor } from './core/interceptors/cache-control.interceptor';
import { errorHandlerInterceptor } from './core/interceptors/error-handler.interceptor';
import { isPlatformBrowser } from '@angular/common';
import { provideClientHydration } from '@angular/platform-browser';

import { routes } from './app.routes';

export function initializeApp(configService: WebAppConfigService, platformId: Object) {
  return () => {
    // Solo cargar config en el navegador, no en SSR
    if (!isPlatformBrowser(platformId)) {
      return Promise.resolve(null);
    }
    
    return configService.loadConfig().toPromise()
      .catch(err => {
        console.error('Error inicializando configuración:', err);
        return null;
      });
  };
}

export function initializeSession(guestSession: GuestSession, platformId: Object) {
  return () => {
    if (!isPlatformBrowser(platformId)) {
      return Promise.resolve(null);
    }

    return guestSession.ensureSession().toPromise()
      .catch(err => {
        console.error('Error iniciando sesión de invitado:', err);
        return null;
      });
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([cacheControlInterceptor, authInterceptor])
    ),
    // Hydration desactivada - causa conflictos con carga dinámica de datos
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [WebAppConfigService, PLATFORM_ID],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeSession,
      deps: [GuestSession, PLATFORM_ID],
      multi: true
    }
  ]
};
